{
  "hero": {
    "title": "NAPAICP 主辦方操作手冊",
    "description": "說明如何從空白建立一場競賽，到開放報名、投稿、評審與公布結果的完整流程。適用 competition_admin 與 staff；平台層級的跨競賽治理請見平台管理操作手冊。"
  },
  "quickNav": {
    "label": "頁內導覽",
    "howToApply": "如何成為主辦方",
    "overview": "角色與權限",
    "setup": "建立競賽",
    "forms": "表單",
    "people": "隊伍與人員",
    "submissionsFiles": "作品與檔案",
    "judging": "評審設定",
    "results": "成績與結果",
    "operations": "營運操作",
    "critical": "務必先看懂的規則",
    "faq": "常見問題",
    "boundary": "與平台管理操作手冊的邊界",
    "events": "活動營運"
  },
  "howToApply": {
    "heading": "如何成為主辦方",
    "description": "若您尚未擁有任何競賽的 competition_admin 或 staff 角色，需先提出正式主辦申請並經平台審核核准，才會取得 competition_admin，開始使用本手冊後續章節說明的功能。",
    "steps": {
      "entry": {
        "title": "1. 找到申請入口",
        "description": "登入後，於右上角 Account Menu（角色與權限與登出之間）點選「申請成為競賽主辦方」，會導向 /competition-requests；此頁面同時是您可以查看自己歷次申請狀態的清單頁。"
      },
      "submit": {
        "title": "2. 填寫並送出申請",
        "description": "於申請表單（/competition-requests/new）填寫欲主辦競賽的基本資訊（名稱、簡介、預計時程與規模等）並送出；此時申請本身不是正式競賽，也不會讓您取得任何 Competition Role。"
      },
      "track": {
        "title": "3. 追蹤審核狀態",
        "description": "送出後狀態為「已送出」或「審核中」；若被要求補件（changes_requested），可在詳情頁依附帶的舊資料重新提交；若不再需要，也可自行撤回尚未核准的申請。所有審核決策（核准／要求補件／拒絕）都會留下稽核紀錄。"
      },
      "approved": {
        "title": "4. 核准後自動取得管理權限",
        "description": "申請核准後，伺服器會一次性自動建立正式競賽並將您設為第一位 competition_admin（此流程具冪等性，重複觸發不會建立第二筆競賽）；核准後可直接從申請詳情頁前往管理後台，接續本手冊「建立競賽」章節的設定流程。"
      }
    }
  },
  "overview": {
    "heading": "角色與權限",
    "description": "本手冊涵蓋兩種 Competition-scoped 角色：competition_admin（可管理自己負責的競賽的完整設定）與 staff（依授予的權限協助營運）。兩者的實際可執行範圍以畫面上顯示的可用操作為準，最終授權判斷一律在伺服器端執行；介面上看不到某個按鈕，不代表該操作真的被禁止，反過來，介面上看得到，也不保證一定成功，伺服器仍會重新驗證權限。",
    "navigationNote": "進入單一競賽後，左側導覽依六個固定順序分組：設定、營運、資料、審查、權限、治理。每個群組標題可個別點擊摺疊／展開，目前所在頁面所屬群組會恆為展開且無法摺疊；摺疊偏好保存在瀏覽器本機，不同裝置/瀏覽器不會同步。本手冊接下來的章節大致依「設定一次性」到「持續營運」的邏輯順序說明，與左側導覽的分組順序不完全一致；日常操作建議以「營運儀表板」（見「營運操作」章節第 1 項）作為每天登入後台的第一站。"
  },
  "setup": {
    "heading": "建立競賽",
    "steps": {
      "create": {
        "title": "1. 建立競賽",
        "description": "建立新競賽並填寫基本資料（名稱、簡介、公開頁面內容）。"
      },
      "createVariants": {
        "title": "2. 建立競賽的其他方式",
        "description": "除了「1. 建立競賽」的空白流程，另有三種建立方式，皆會先建立一筆 Competition Creation Request，需經平台管理員核准後才會正式建立為競賽，與空白建立相同：（a）「從範本建立」（競賽列表頁按鈕）：從既有的平台共用範本或自己建立的私人範本中選一個，填寫名稱／網址代稱／年份，並選擇日期策略（清除：建立後所有日期需重新設定；保留：沿用原本日期，若已過期會顯示警告；平移：以指定的錨點日期將整組時程按比例平移到新的時間點）；（b）「從 JSON 匯入」（競賽列表頁按鈕）：貼上或上傳 .napaicp.json 設定檔，先按「驗證」取得 Preflight 結果（來源名稱、schema 版本、是否可建立、警告與阻擋錯誤），確認可建立後才需要填寫名稱／網址代稱／年份與日期策略並送出；（c）「複製此競賽」／「儲存為範本」（進入任一您已管理的競賽 → 總覽頁「更多操作」選單）：「複製此競賽」以該競賽目前設定建立新的 Creation Request（可選擇是否一併複製公開頁面文字與評審設定，並選擇日期策略），「儲存為範本」則把該競賽目前設定另存為一份可重複使用的範本（可設定僅自己可見或平台所有主辦方可見），供之後「從範本建立」使用，本身不會建立新競賽。同一「更多操作」選單另有「匯出競賽設定」，可下載目前競賽的 .napaicp.json 設定檔，作為「從 JSON 匯入」的來源檔案或單純備份用途。四種建立方式在核准前皆可在申請詳情頁追蹤審核狀態，核准後的自動建立行為與「如何成為主辦方」章節第 4 項相同。"
      },
      "status": {
        "title": "3. 競賽狀態",
        "description": "競賽有多個狀態（例如尚未開始、報名開放、投稿階段、評審中、已結束），實際可用的狀態轉換以畫面顯示為準。"
      },
      "schedule": {
        "title": "4. 報名／投稿／評審／結果時程",
        "description": "設定各階段的起訖時間；每個 Round（初賽／決賽）可以有各自獨立的時程。\n\n賽程日期以「賽程輪次」為準：請在「賽程輪次」頁編輯各輪次的報名、繳交、評審與結果公布時間；總覽頁顯示的競賽層級日期，由系統依各輪次自動同步為最早開始與最晚結束，不需要也不應另外修改。報名與作品繳交的時間可以重疊，重疊期間競賽狀態顯示為「報名中」，已完成報名與團隊設定的參賽者仍可開始或繼續準備作品；報名截止與繳交截止都以目前輪次的日期判斷，延長輪次的日期後，公開頁、參賽者頁與伺服器端的截止判斷會一致更新。"
      },
      "eligibility": {
        "title": "5. Eligibility",
        "description": "設定參賽資格條件，公開頁面會顯示給潛在參賽者參考。"
      },
      "categories": {
        "title": "6. Categories／組別",
        "description": "視需要建立競賽組別，供報名與後續評審、結果依組別區分。每個組別可選填「名額」欄位，設定後系統會在報名時實際擋下超額報名（隊伍名額已滿的組別無法再建立新隊伍或轉入既有隊伍），留空則不限制。"
      },
      "rounds": {
        "title": "7. Rounds／初賽／決賽",
        "description": "視需要建立多輪賽制；只有明確晉級的隊伍才能進入下一輪。"
      },
      "publicContent": {
        "title": "8. 公開頁面內容設定",
        "description": "在競賽總覽頁的「設定」編輯抽屜可設定：聯絡 Email、是否公開此競賽頁面（/c/:slug）、以及 6 個選填的公開頁面文字區塊：參賽資格、作品繳交規定、評選標準、獎項、主辦單位聯絡方式，以及常見問答（FAQ，可自行新增／移除多筆問答，無筆數上限）。任一文字欄位未填寫時，公開頁面上對應的區塊會完全不顯示（不會顯示空白標題），因此可以先啟用公開頁面、之後再逐步補齊內容。"
      },
      "studentEligibilityPolicy": {
        "title": "9. 學生資格驗證政策設定",
        "description": "總覽頁的「學生資格驗證」卡片（與第 5 項「Eligibility」的公開說明文字是兩件不同的事：後者只是公開頁面上的文字，系統不會強制檢查）可個別為此競賽開關本功能，並設定：驗證範圍（全部學生成員／全部參賽成員／僅隊長／團隊最少驗證人數）、可接受的證明類型（在學證明書／學生證／其他經核准文件）、是否需要人工審核、待審核期間是否可先完成報名（預設允許）、證明有效天數。啟用後，符合範圍的成員需至自己的「學生資格驗證」頁上傳證明並經審核通過，才能通過報名時的伺服器端資格檢查；此檢查永遠即時依成員目前的驗證狀態與團隊組成重新計算，團隊成員異動後不需要任何人重新儲存報名表單。系統會在該場競賽結束滿 365 天後自動刪除已上傳的原始證明檔案，僅保留審核結果與稽核紀錄；此為系統自動排程行為，目前沒有另外的手動觸發畫面。"
      }
    }
  },
  "forms": {
    "heading": "表單",
    "steps": {
      "registrationForm": {
        "title": "1. 報名表單",
        "description": "建立報名表單並命名；建立時必須輸入名稱，不會自動套用通用型別文字。"
      },
      "teamForm": {
        "title": "2. 團隊表單",
        "description": "建立團隊表單，收集隊伍本身（而非個別成員）的相關資訊，與成員資料分開管理。"
      },
      "submissionForm": {
        "title": "3. 投稿表單",
        "description": "建立作品繳交表單，定義參賽者需要填寫與上傳的內容。"
      },
      "judgeConflictForm": {
        "title": "4. 評審利益迴避表單",
        "description": "建立評審利益迴避表單，供評審在評分前申報是否與特定作品有利益衝突；除此表單外，評審也可以在自己的指派清單中直接點選「申報利益迴避」自行申報，兩種來源都會顯示在「評審邀請與指派」頁的「利益衝突」分頁。"
      },
      "versioning": {
        "title": "5. 表單版本與發布",
        "description": "以上四種表單皆可版本化管理；已發布的版本不可再修改內容，需要調整時建立新版本並重新發布。既有表單可以重新命名。\n\n表單改版後，已完成報名的學生不會被自動退回；但若他們先前儲存的答案不符合新版的必填規則（例如新增了必填欄位），系統會把他們標示為「需補填」，主辦方可在「報名資料」頁看到名單（見「隊伍與人員」章節的「需補填的報名資料」）。"
      }
    }
  },
  "formsDepth": {
    "sub": {
      "fieldTypes": {
        "heading": "欄位類型",
        "description": "表單編輯器支援 21 種欄位類型：文字類（單行文字、多行文字、格式化文字、Email、電話、網址）、數字與日期（數字、日期、日期時間）、選擇類（單選、核取方塊、下拉選單、多選下拉）、布林（是／否）、檔案類（一般檔案、圖片、PDF、ZIP），以及純版面用途、不收集答案的三種欄位（標題、說明文字、分隔線）。提醒：「網址」欄位的答案會顯示給評審（評分頁「作品連結」，僅最終送出版本）；若是 YouTube 或 Vimeo 網址，評審可在頁內直接播放。匿名評審時，請提醒參賽者影片內不要出現隊名、校名或可辨識身分的內容。"
      },
      "sectionGrouping": {
        "heading": "所屬區塊（選填）",
        "description": "每個欄位皆可另外填寫一個「所屬區塊」名稱（選填，例如「提案簡報」）；只要多個欄位填入完全相同的區塊名稱，這些欄位就會在參賽者的作品工作區顯示為同一個區塊標題底下的一組欄位，方便參賽者依區塊檢查填寫完成度。留空的欄位維持獨立顯示，不受影響。此設定僅影響參賽者填寫端的視覺分組，不影響驗證規則或必填判斷。"
      },
      "validation": {
        "heading": "驗證規則",
        "description": "每個欄位皆可設定對應的驗證規則：文字類欄位可設定最小／最大長度與正規表示式（pattern）；數字欄位可設定最小／最大值；檔案類欄位可設定允許的副檔名與檔案大小上限。不符合規則的答案會在參賽者送出當下被擋下並具名指出問題欄位。\n\n必填的勾選框（布林欄位，例如「團隊聲明」）代表「必須勾選」：沒有勾選時，參賽者無法完成報名，伺服器也會拒絕；非必填的勾選框可以不勾。"
      },
      "conditionalVisibility": {
        "heading": "條件式顯示欄位",
        "description": "欄位可設定「只有當另一個欄位的答案符合條件時才顯示」的條件（支援等於／不等於，並可用 AND／OR 組合多條件）。條件不成立時該欄位在填寫端會被隱藏；隱藏期間若原本已有填寫值，該值會被清除，不會殘留在背後送出，可放心設計分支式表單。"
      },
      "preview": {
        "heading": "發布前預覽",
        "description": "編輯器提供「預覽表單」按鈕，會開啟「參賽者預覽」側欄，以參賽者實際會看到的版面（含必填標記與條件式顯示的即時效果）呈現目前編輯的版本（草稿優先）。預覽是可以操作的：您可以直接選擇下拉選單或勾選項目，馬上看到條件式顯示欄位在各種選擇下的呈現（例如選擇 A 組時會出現哪些欄位、選擇 B 組時又是哪些），方便在發布前逐一檢查各分支；但預覽不會送出或儲存任何資料，檔案類欄位也無法在預覽中上傳，也無法測試送出不合法資料時的錯誤訊息。"
      },
      "fieldReorder": {
        "heading": "欄位排序",
        "description": "可用拖曳、鍵盤或上下移按鈕調整欄位順序，動作會立即反映於畫面（不必等待儲存完成）；若儲存失敗，畫面會自動還原為原本順序並顯示錯誤訊息，請再試一次。若目前編輯的是已發布版本，調整順序會先依既有規則自動建立新草稿版本，再套用排序。"
      }
    }
  },
  "people": {
    "heading": "隊伍與人員",
    "steps": {
      "competitionPeople": {
        "title": "1. Competition People / Roles",
        "description": "查看該競賽內所有具角色的使用者，並依角色篩選。"
      },
      "staff": {
        "title": "2. Staff 管理",
        "description": "以 Email 授予 staff 角色（該帳號需至少登入過一次）；目前是整體角色授予，畫面上沒有逐項勾選權限範圍的介面，staff 實際能操作的功能由各頁面自己的權限規則決定。"
      },
      "teams": {
        "title": "3. 隊伍管理（Team Operations Matrix）",
        "description": "「營運」分組的「隊伍管理」是一張彙整全部隊伍營運狀態的表格（隊伍名稱、類別、隊長、成員數可展開查看名單、報名、資格證明、資格通過、作品狀態、審查進度、注意事項旗標、更新時間），可依報名狀態篩選並可用「另存目前篩選為檢視」把常用篩選組合存成具名檢視（純瀏覽器本機偏好，不影響其他管理員看到的資料）。工具列另提供「傳送報名提醒」：一鍵寄送提醒信給所有尚未完成報名的隊伍隊長，送出前會先顯示確認對話框，送出後顯示伺服器實際回報的收件人數；此功能沒有伺服器端冷卻或頻率限制，請自行斟酌使用頻率避免同一隊長收到過多信件。必要時仍可在此協助處理隊伍相關個案問題。\n\n送出前的確認對話框會同時顯示「信件預覽」：即將寄出的信件主旨與內文（以第一支會收到的隊伍為範例，每位隊長收到的信會寫上自己的隊名，預覽為純文字，實際信件另有排版），確認無誤再按「傳送提醒」。信末會附上競賽設定中的「主辦單位聯絡信箱」。注意：此提醒的對象是「尚未完成報名（沒有報名資料）」的隊伍隊長；已完成報名但答案需要補填的學生，請改用「報名資料」頁的「需補填的報名資料」。"
      },
      "submissionCheck": {
        "title": "4. 投稿與檔案檢查",
        "description": "查看各隊伍的投稿狀態與已上傳檔案，掌握整體投稿進度；詳細操作見下方「作品與檔案」章節。"
      },
      "eligibilityReview": {
        "title": "5. 資格驗證審核",
        "description": "若已在「建立競賽」章節開啟學生資格驗證政策，「隊伍與人員」頁會多出一個「資格驗證」分頁（僅具 eligibility.review 權限者可見，預設僅 competition_admin，不含 staff），提供已通過／待審核／未通過三項彙總磚，並可依狀態、隊伍、姓名/Email/學校篩選成員清單。點開任一筆會開啟審核 Drawer：可安全線上預覽或下載該成員已上傳的在學證明（僅預覽/下載，無法編輯成員自行填寫的資料），並選擇「通過」或「未通過」（未通過必須填寫理由），送出後立即生效，該成員的資格狀態與團隊完成度會即時更新。「營運」分組另提供完全相同工作台的直接入口「資格驗證審核」，兩者共用同一份資料與篩選狀態，包含同款「另存目前篩選為檢視」功能，走哪一個入口都可以。\n\n審核選擇「未通過」時，系統會以 Email 通知該學生，內容包含您填寫的原因，審核抽屜會事先提示這一點，請留意措辭；選擇「通過」時不會寄信。這封通知信的寄送成功或失敗會記錄在稽核紀錄。"
      },
      "participants": {
        "title": "6. 參賽者總表",
        "description": "左側導覽「資料」分組下的「參賽者」頁提供全競賽層級的參賽者總表（僅隊長與隊員，與本節前面說明的工作人員／管理員／評審等治理角色分開），欄位含姓名、Email、隊伍、隊伍角色、類別、學校、系所、資格驗證狀態、報名狀態，支援依隊伍、類別、資格狀態、報名狀態篩選與依姓名/Email/學校搜尋，篩選條件會保留在網址列以便分享或返回。"
      },
      "dataViews": {
        "title": "7. 報名資料與資格驗證資料檢視",
        "description": "「資料」分組另提供兩個唯讀檢視頁：「報名資料」列出所有隊伍的報名表填答狀態與最後修改時間（僅供查看，不影響報名完成度判定，報名完成度與資格驗證狀態完全無關）；「資格驗證資料」是本節「資格驗證審核」工作台的唯讀延伸（完全相同的資料來源，非另一套資料），額外呈現證明版本歷程與是否已依保存政策清除檔案，但不提供通過／退回操作，實際審核仍請至「資格驗證審核」分頁進行。\n\n「報名資料」頁最上方另有「需補填的報名資料」區塊，見下一項。"
      },
      "registrationNeedsUpdate": {
        "title": "8. 需補填的報名資料",
        "description": "「資料」分組的「報名資料」頁最上方，有一個「需補填的報名資料」區塊，列出「已完成報名，但已儲存的答案不符合目前已發布表單」的學生：每一列顯示姓名、所屬隊伍與尚需補填的欄位（例如「團隊聲明」），沒有人需要補填時整個區塊不顯示。常見原因是表單改版後新增了必填欄位，或必填的勾選框先前是未勾選的狀態。學生在自己的畫面上（競賽頁、我的競賽卡片、首頁）也會看到「需補填」。具備隊伍管理權限的人可以使用兩個按鈕：（1）「寄測試信給我自己」：把同一封信寄到您登入帳號的信箱，主旨標示【測試】，不會寄給任何學生，用來先看信件實際的樣子；（2）「傳送補填提醒」：先出現確認對話框，顯示收件人數與「信件預覽」（主旨與內文，以名單中第一位學生為範例），確認無誤再按「傳送提醒」。提醒信只會寄給該學生本人（不寄給隊長或教師），列出他缺少的欄位與補填連結，信末附上主辦單位聯絡信箱。系統不會替學生填寫或勾選任何內容，包括聲明；學生補填並儲存後，會自動從名單消失。此功能沒有冷卻或頻率限制，按下並看到成功訊息後請勿重複按，以免學生收到重複信件。"
      }
    }
  },
  "submissionsFiles": {
    "heading": "作品與檔案",
    "description": "本章節說明主辦方在「投稿管理」頁實際能做到的事：查詢、檢視、下載；並如實標註目前後台介面還沒有的操作，避免誤以為某個功能已經可以點擊使用。",
    "sub": {
      "filter": {
        "heading": "查詢與篩選投稿清單",
        "description": "投稿清單支援依狀態（草稿／就緒／已提交／已鎖定／已撤回／已取消資格）篩選、依輪次（初賽／決賽）與組別篩選、依隊伍 ID 文字搜尋，並提供分頁；資料表依序顯示隊伍、輪次、組別、狀態、提交時間（同一隊的初賽與決賽作品各自一列，決賽作品不會覆蓋初賽作品）。此頁需要 submission.read.all 權限。"
      },
      "detail": {
        "heading": "投稿詳情",
        "description": "點開任一筆投稿可查看狀態徽章、提交時間、所屬隊伍名稱等基本資訊。"
      },
      "filesAnswers": {
        "heading": "檔案與已送出答案",
        "description": "投稿詳情頁列出該筆投稿的所有已上傳檔案，每個檔案皆提供「線上預覽」與「下載」；同時列出參賽者填寫的所有表單答案（以欄位名稱／答案值的方式呈現）。若想跨隊伍、跨投稿一次查看全競賽所有已上傳檔案，可改用「資料」分組的「檔案」頁：同樣的下載能力，但以檔名、隊伍、類型、大小、狀態為欄位的單一表格呈現，可依狀態或投稿 ID 篩選，適合快速盤點整場競賽的檔案而不必逐筆點開投稿詳情。"
      },
      "versions": {
        "heading": "版本歷程",
        "description": "詳情頁提供該筆投稿的版本歷程，唯讀呈現，用於回溯查看歷次提交內容；若您同時具備 score.read 或 score.manage 權限，也會在同一頁看到各評審的評分與「重新開放」操作（見「成績與結果」章節）。"
      },
      "actions": {
        "heading": "投稿狀態操作：鎖定／解鎖／撤回／取消資格／退回修正",
        "description": "若您具備 submission.manage 權限，投稿詳情頁會顯示對應的操作按鈕：對「已提交」的投稿可以「鎖定」（轉為已鎖定，供評審審閱期間避免再被更動）；對「已提交」或「已鎖定」的投稿可以「解鎖」（轉回「已就緒」，讓團隊可重新編輯並再次正式提交，不寄信通知）、「撤回」、「取消資格」、或「退回修正」（同樣轉回「已就緒」，但會另外寄信通知團隊需要修改的原因：這是與「解鎖」的差異所在）。注意：「取消資格」作用於整支隊伍（隊伍成員會收到通知信，不含原因；競賽管理員可在已取消資格的作品詳情頁用「復原取消資格」還原到取消前的狀態並通知隊伍，原因必填且留稽核；復原不會自動重算結果或恢復已取消的評審指派，請手動重新計算與重新指派），而不只該件作品：該隊在所有輪次都不能再建立、修改或送出作品；結果計算會排除該隊（含已晉級後才取消資格的情況，已鎖定的評分保留但不計入，並列入「未納入」名單）；也不能再被晉級到下一輪。每個輪次的繳交是各自獨立的作品紀錄，進入決賽後新增的決賽作品不會覆蓋初賽作品。取消資格後的處理：取消資格時系統會自動取消該隊尚未送出的評審指派（已送出的評分保留，評審會收到彙整的調整通知），下面的一步取消按鈕則用來處理取消資格前就存在的指派。結果頁會把「已取消資格（不計入）」與「缺少評分」分開列出，並在公布前顯示警示；評審端對該作品顯示「無需評分」（不會說明原因）且不再催審；在「評審邀請與指派」的指派清單，該隊的列會標示「已取消資格」，並可用「取消失格隊伍的評審指派」一步取消尚未送出的指派（需填原因；已送出的評分保留）。取消資格隊伍的作品也無法再被指派：單筆指派會被拒絕，批次與自動分配會略過。五個操作皆須填寫理由，理由會保留於稽核紀錄；確認後立即生效，沒有復原按鈕，執行前請先確認影響範圍。"
      }
    }
  },
  "judging": {
    "heading": "評審設定",
    "helpCta": "操作：如何邀請評審",
    "steps": {
      "invite": {
        "title": "1. 邀請評審",
        "description": "在「評審邀請與指派」頁的「邀請管理」分頁輸入評審 Email 送出邀請（單一動作，沒有另外的「建立評審」步驟）；若該 Email 尚無帳號，系統會自動建立帳號並寄送臨時密碼。可查看邀請紀錄，對待接受的邀請重新發送或取消。\n\n邀請信（含重新發送）的寄送成功或失敗，會記錄在稽核紀錄（動作為「系統寄出了通知信」，不含 Email 位址）；寄信失敗不會使邀請失敗，可以稍後使用「重新發送」。已有帳號的受邀者登入後會在「總覽」頁看到邀請，可「接受」或「婉拒」（可附原因）；婉拒的邀請在邀請列表顯示「已婉拒」與原因，可再次邀請同一個人。"
      },
      "assign": {
        "title": "2. 評審指派",
        "description": "在「作品指派」分頁將作品指派給評審，可支援批次勾選多件作品與多位評審、對同一評分標準版本一次建立所有組合；重複或有利益衝突的組合會被略過並回報原因，不會讓整批請求失敗。「作品指派」分頁最上方的「自動平均分配」可選輪次、評分規準與每件作品的評審人數，先預覽（顯示每位評審目前工作量與新增件數、無法補足的作品數），確認後才建立；依工作量與類別平均分配，並略過利益衝突與已存在的指派。評審會在約 10 分鐘後收到一封彙整的新指派通知。自動分配在負載相同時，會優先選擇「專長」與類別名稱相符的評審（專長為評審自填的文字，僅作為次要依據，不會讓工作量不平均）。作品被您改派或取消時，原評審約 10 分鐘後會收到一封彙整的調整通知，通知不含原因。"
      },
      "conflict": {
        "title": "3. Conflict of Interest",
        "description": "在「評審邀請與指派」頁的「利益衝突」分頁，可查看該競賽所有已申報的利益衝突（評審、隊伍、原因、來源、申報時間），此為唯讀清單；若某筆衝突與目前進行中的指派重疊，可直接在「審查進度」頁（本章節第 8 項）點擊「重新指派」處理，不需要在此分頁操作。利益衝突主要透過評審自行申報，或「評審利益迴避表單」（表單章節）收集，並在批次指派時自動略過有衝突的組合並顯示原因，計算成績時也會追溯排除受影響的鎖定分數。"
      },
      "rubric": {
        "title": "4. Rubric／評分規準",
        "description": "建立評分規準與評分項目，每個評分項目可填寫定義說明；評分規準的個別版本可以命名（例如「初賽」「決賽」）。建議在每個評分項目的說明中寫出各分數級距的判斷標準與例子（例如「9–10 分：…；5–6 分：…」），評審評分時可展開查看，能明顯降低評審之間的評分落差。每個評分項目還可新增結構化的「分數級距範例」（最低分、最高分與說明，最多 12 筆），評審評分時展開即可看到。總分一律以 100 分為滿分：每個項目依「得分 ÷ 該項最高分 × 權重」換算，所以各項目用 0 到 10 或 0 到 100 計分都可以，也可以彼此不同。"
      },
      "progress": {
        "title": "5. 評分進度",
        "description": "追蹤各評審的評分進度，掌握截止前是否有尚未完成的指派。"
      },
      "scoreVisibility": {
        "title": "6. 查看評審評分與意見",
        "description": "具 score.read 權限者可在作品的投稿詳情頁，以及「結果審查」頁每一列的「查看評審的審查意見」展開區，查看各評審的鎖定狀態、總分，以及評審填寫的「審查意見」；評審的個人評審備註（僅供評審本人參考）不會出現在此，主辦方看不到。兩位以上評審已送出時，另有「分項比較」表格並排顯示各評審在每個評分項目的分數與差距，差距達該項目滿分 30% 以上的會以顏色標示。"
      },
      "reviewCommentRequired": {
        "title": "7. 評分作業設定：審查意見必填",
        "description": "在競賽「設定」編輯抽屜可開啟「評審必須填寫『審查意見』才能送出評分」。開啟後僅在評審正式送出評分時強制檢查（儲存草稿不受影響），未填寫審查意見會無法正式送出。此設定預設為關閉、依競賽個別開關，不影響其他既有競賽，可隨時開啟或關閉。"
      },
      "judgingLoad": {
        "title": "8. 審查進度與利益衝突警示",
        "description": "「審查」分組的「審查進度」頁（URL 仍是 /judging-load，僅畫面標籤更名）提供每位評審的負載表格（指派件數、已完成、待評、已申報衝突數、最近活動）與統計啟發式旗標（「工作量過重」「近期無活動」「指派不足」等，僅為操作提示，並非對特定評審的評斷）。頁面另會比對每位評審的利益衝突宣告與目前進行中的作品指派，標示出「已宣告迴避但仍持有相同作品進行中指派」的異常情形；此為需要處理的資料異常，每列提供「重新指派」（直接在本頁選擇一位新評審，系統會對新評審重新驗證利益衝突後才建立新指派並移除舊指派，不需再繞去「作品指派」分頁）為主要動作，「僅取消指派」（不指定新評審，需填寫原因）為次要動作。頁面上方的「提醒評審完成評分」會列出仍有未送出評分的評審（已申報利益迴避的作品不計入）與其未完成件數，具評審管理權限者可預覽信件後一鍵寄送提醒（信中含未完成件數、最近的審查截止時間與前往評審任務的連結），每次寄送記錄一筆稽核。評審若臨時無法擔任，可在自己的評審任務頁填寫原因後退出，其尚未送出評分的指派會被取消並留下稽核紀錄，您可在本頁看到該評審的指派件數下降並重新指派。「提醒評審完成評分」卡片另有「截止前自動提醒評審」開關（預設關閉）：開啟並設定提前小時數後，系統會在每個輪次的審查截止前，自動對仍有未送出評分的評審各寄一次提醒（每輪只寄一次）。"
      },
      "manualScoring": {
        "title": "9. 輪次手動輸入評分",
        "description": "在「賽程輪次」頁可為每個輪次選擇評分輸入方式：僅評審評分（預設）、僅工作人員輸入、評審加工作人員輸入，並設定手動輸入欄位（名稱、分數範圍、加分／扣分／僅記錄）。工作人員在「審查 → 手動輸入」頁輸入各隊數值，只能在輪次「開放中」或「評審中」且結果尚未鎖定時輸入，超出範圍會被拒絕。結果計算會依模式納入手動輸入，作品成績明細標示每筆分數來自評審或工作人員輸入，並保留輸入者、時間與修改前後數值的紀錄。結果鎖定後，模式、欄位與輸入資料都不能再修改。"
      }
    }
  },
  "results": {
    "heading": "成績與結果",
    "helpCta": "操作：如何重新開放評分",
    "steps": {
      "lockReopen": {
        "title": "1. 評分鎖定 / 重開",
        "description": "評審正式送出的分數會鎖定；具 score.manage 權限的主辦方可在該作品「投稿詳情」頁的分數區塊，對已鎖定的分數點擊「重新開放」，填寫必填理由後確認，即可讓該評審重新修改並送出分數，不需要再向平台管理端申請；此操作會建立稽核紀錄與修改歷程，不是直接覆蓋原始分數。"
      },
      "calculate": {
        "title": "2. 成績計算",
        "description": "依 Round 與可選 Category 計算成績，建立成績運算結果（result run）。點擊「計算結果」會先顯示風險警示文字（說明只會納入至少 2 位評審完成鎖定評分的作品，未達門檻者將列為「缺少有效評分」），需再次點擊「確認計算」才會真正觸發，避免誤按。每個 Result Run 卡片會完整呈現這次計算的中繼資料：Run ID、賽程輪次、組別、計算時間、計算者、已納入評分數、缺少有效評分數（附隊伍名稱）、以及並列訊號（如有）。單一作品須至少有 2 位評審的有效鎖定分數才會被納入排名；未達門檻的作品會被排除在該次結果之外（不是計算失敗，是刻意排除），需要補齊評審評分後重新計算。評審若在分數鎖定後才被登記利益衝突，該筆分數計算時一律追溯排除，即使技術上仍是鎖定狀態。"
      },
      "review": {
        "title": "3. 人工覆核",
        "description": "計算結果建議在鎖定前人工覆核，確認無誤。作品「投稿詳情」的評分區塊在兩位以上評審已送出分數且最高與最低相差 20 分以上時，會顯示「評審分數差異大」提醒，僅供主辦方參考，不會自動排除任何分數；必要時可請評審覆核（重新開放）。"
      },
      "advance": {
        "title": "4. 晉級",
        "description": "明確將符合資格的隊伍從初賽晉級決賽；晉級操作具冪等性，重複執行不會造成重複晉級。\n\n確認畫面會說明：系統會以 Email 通知入圍隊伍的隊員（不含教師）；寄送成功與失敗的人數會記錄在稽核紀錄。"
      },
      "award": {
        "title": "5. 獎項／名次",
        "description": "確認獎項標籤後即可準備公布。"
      },
      "lock": {
        "title": "6. 鎖定結果",
        "description": "「鎖定」是與「發布」分開的獨立按鈕，且各自寫入稽核紀錄與各自的操作者。點擊「鎖定」會先顯示影響說明文字（鎖定後仍可調整獎項等第（須附理由），直到公布為止，但不影響其他結果紀錄、紀錄本身也不會被刪除），需再次點擊確認才會真正觸發。鎖定後 Result Run 卡片會多顯示「鎖定者」。"
      },
      "publish": {
        "title": "7. 公布結果",
        "description": "發布是鎖定之後的下一步，同樣是獨立按鈕、獨立稽核紀錄；發布後 Result Run 卡片會多顯示「發布者」。公布後該次結果即不可再變更；公布前（包含已鎖定時）仍可調整獎項等第，公布後如需修正須重新計算新的一次結果。此結果紀錄卡片目前刻意不呈現所使用的評分規準版本，屬已知待補項目。"
      }
    }
  },
  "operations": {
    "heading": "營運操作",
    "steps": {
      "opsDashboard": {
        "title": "1. 營運儀表板",
        "description": "「營運」分組的「營運儀表板」是進入單一競賽後台後最先該看的頁面，「待處理事項」卡片固定顯示在最上方、所有 KPI 群組之前，並依目前競賽階段（報名期/繳件期/評審期/結果公布）調整項目排序，讓最急迫的類別優先出現。下方一次呈現報名、參賽者、資格驗證、作品繳交、評審五組即時 KPI，每組皆附分母（例如「7 / 8」），分母為零時顯示「N/A」而非誤導性的 100%；每個數字皆可點擊，直接帶入對應清單頁的篩選條件。每個 KPI 群組標題旁有「隱藏」按鈕可個別收起，隱藏後頁面上方出現「已隱藏：...」摘要列可個別「顯示」還原，此偏好僅存在瀏覽器本機、依競賽分別記憶；「待處理事項」卡片本身沒有隱藏選項。報名與資格驗證是兩條完全獨立的業務軸：資格驗證審核中／已退回／已過期／尚未提交都不會讓已完成的報名被重新算成未完成，儀表板與其他頁面皆不會混算兩者。此頁不取代「總覽」（設定完整度），兩者並存，各自回答不同問題。"
      },
      "deadlineExtend": {
        "title": "2. Deadline 延長",
        "description": "沒有獨立的「延長截止時間」按鈕；延長方式是直接在該輪次的排程表單中修改對應的截止時間並儲存，此操作會產生對應的稽核紀錄。"
      },
      "auditLog": {
        "title": "3. Audit Log",
        "description": "查看該競賽的操作紀錄（成績、權限、重要狀態異動），主要文字以人類可讀的語句呈現（例如「某某人通過了資格驗證」），可依分類篩選並可自由文字搜尋；原始事件代碼與被操作對象等技術性細節不常駐顯示，收在每筆紀錄的「檢視變更內容」漸進式揭露區塊內。稽核紀錄唯讀，不提供刪除或修改。\n\n與寄信相關的動作也會列入：例如「編輯了公告」「刪除了公告」「以 Email 寄送了公告」（記錄收件人數、名單與篩選條件，不含 Email 位址）、「寄送了公告 Email 的測試信給自己」、「傳送了報名資料補填提醒」、「寄送了報名資料補填提醒的測試信給自己」，以及「系統寄出了通知信」（晉級、作品退回、資格驗證未通過、評審邀請的寄送成功與失敗數）。"
      },
      "exportCenter": {
        "title": "4. 匯出中心",
        "description": "「資料」分組的「匯出中心」提供隊伍、作品、參賽者、資格驗證、報名資料、評審、評分與審查意見共 7 種伺服端 CSV/XLSX 報表（「評分與審查意見」每位評審對每件作品一列，含總分、各項分數與審查意見，僅列已送出的評分，需具 score.read 權限，不含評審個人備註），可選擇欄位、套用目前篩選條件；每張報表卡片在下載按鈕之前會即時顯示「將匯出 N 筆」與目前篩選摘要（無篩選時顯示「無」），可在真正下載前先確認匯出範圍，此筆數查詢本身不會被記錄為一次匯出。資格驗證與報名資料兩種報表刻意不包含證明檔案本體、私有物件金鑰、簽章網址或表單原始填答內容。每次真正觸發下載的匯出（包含既有的隊伍與作品匯出）都會留下稽核紀錄（操作者、報表種類、篩選條件、筆數、時間），可在同頁「匯出紀錄」查看。"
      },
      "globalSearch": {
        "title": "5. 全站搜尋",
        "description": "競賽後台頁首提供跨隊伍、參賽者、作品、評審的搜尋框，輸入至少 2 個字即會分組顯示結果，點擊任一筆可直接導向對應頁面。搜尋結果依您實際持有的權限裁切：例如僅具一般營運權限、未具評審管理權限者，搜尋結果不會出現評審姓名與 Email。"
      },
      "announcements": {
        "title": "6. 公告管理與 Email 通知",
        "description": "「營運」分組的「公告」頁，讓您新增、編輯、刪除競賽公告。公告有標題、內容（純文字，換行會保留，網址會自動變成連結）與「顯示對象（網站）」：全部（含訪客）、參賽者、評審，只決定網站上誰看得到，公告會顯示在公開競賽頁與參賽者的「競賽資訊」頁。表單提供「預覽」（以純文字預覽公告），以及「寄測試信給我自己」。網站公告與 Email 是兩件事：只按「發布公告」不會寄出任何信。要同時寄信，請勾選「同時寄 Email 通知」並選擇收件人：角色（學生、教師、評審，預設全選），並可再依類別、依輪次（第一輪為所有有效隊伍，後續輪次為已晉級的隊伍）、依報名欄位（例如「參賽組別」的某個選項）縮小範圍；這些條件只縮小學生與教師，不影響評審。畫面會即時顯示「預計寄送：N 位收件人」（收件人只包含在本競賽持有所選角色、且帳號正常的人；人數為 0 時無法寄送）。按「發布並寄送 Email」後，會先出現確認對話框，顯示人數與「信件預覽」（實際會寄出的主旨與內文），確認前不會建立公告，也不會寄信，按「取消」就什麼都不會發生；按「確認寄送」後才會建立公告並寄出。也可以對已發布的公告在清單上按「寄送 Email」；清單會顯示每則公告是否已寄過與寄給幾位，已寄過的公告再次寄送，對話框會提醒收件人將收到重複的信。每次寄送上限 300 位，超過時請縮小條件、分批寄送；第一次使用建議先用「寄測試信給我自己」與小範圍條件。信件內文一律當作純文字處理（不支援格式與附件），信末註明為競賽官方通知並附上主辦單位聯絡信箱。已寄出的 Email 無法收回，之後編輯或刪除公告也不會更新已寄出的信。"
      },
      "emailNotifications": {
        "title": "7. 通知信與寄送紀錄",
        "description": "主辦方在系統上可能觸發的信件有兩類。手動寄送：公告 Email、需補填的報名資料提醒、給隊長的報名提醒（隊伍管理頁），這三種在寄出前都會顯示人數確認，也都有信件預覽。操作連帶通知：晉級決賽（通知入圍隊伍的隊員，不含教師）、作品退回修改（通知該隊隊員）、資格驗證未通過（通知該學生並附原因）、邀請或重新發送評審邀請（通知該評審，新帳號會附一次性臨時登入資訊），這些會在您做該項操作時自動寄出，操作畫面會事先說明。各種提醒與公告信的信末，會附上競賽設定中的「聯絡信箱」（在總覽頁的「設定」卡片維護，顯示為「主辦單位聯絡信箱」）；沒有填寫時信件不會出現這一行，請確認它填的是要給參賽者聯絡的信箱。「主辦單位聯絡方式」那段長篇文字只用於網站頁面，不會放進信件。每一次寄送（不論手動或連帶）都會在稽核紀錄留下摘要，包含成功與失敗的人數，但不含 Email 位址；寄信失敗不會使原本的操作失敗，畫面也不會即時提示失敗人數，需要到稽核紀錄查看。"
      }
    }
  },
  "critical": {
    "heading": "務必先看懂的規則",
    "items": {
      "serverSideAuth": "介面上是否顯示某個按鈕，不是真正的權限依據；真正的授權判斷一律在伺服器端執行，即使直接呼叫 API 也一樣會被檢查。",
      "adminVsStaff": "competition_admin 與 staff 的可執行範圍不同，實際差異以畫面顯示的可用操作為準；不確定時請以較保守的假設操作，避免誤觸高敏感功能。",
      "auditedActions": "涉及權限、成績、Deadline、結果公布、評分鎖定/重開的操作都會留下稽核紀錄，包含操作者、時間與原因；不要把這些操作當成可以無痕撤回的動作。",
      "publishIsFinal": "結果一旦鎖定並公布即不可變更，公布前務必完成所有覆核。",
      "noOtherCompetitions": "競賽管理僅限於自己被授權的競賽，無法管理或查看其他競賽的內部資料。",
      "resultQuorum": "計算結果時，單一作品至少要有 2 位評審的有效鎖定分數才會被計入排名；只有 1 位（或 0 位）評審完成的作品會被排除在該次結果之外。指派評審時請確保每件作品至少有 2 位評審，否則競賽將無法產生任何排名結果。"
    }
  },
  "faq": {
    "heading": "常見問題與錯誤排除",
    "items": {
      "assignFailPartial": {
        "q": "批次指派評審時部分組合失敗？",
        "a": "系統會逐一略過重複或有利益衝突的組合並回報原因，不會因單一組合失敗而讓整批請求失敗；請依回報的原因個別處理。"
      },
      "cannotEditPublished": {
        "q": "已發布的表單版本無法修改？",
        "a": "已發布版本設計上不可修改，請建立新版本並重新發布；既有已提交的答案仍綁定原本的表單版本。"
      },
      "resultLocked": {
        "q": "成績已鎖定/公布，還能修改嗎？",
        "a": "已公布的結果不可再變更；若真的需要修正，需視情況另外走具稽核紀錄的例外處理程序，不建議直接更動已公布資料。"
      },
      "resultMissingSubmission": {
        "q": "計算結果後，有些作品不見了、沒有名次？",
        "a": "這是預期行為，不是錯誤。單一作品須至少有 2 位評審的有效鎖定分數才會被計入該次結果；只有 1 位（或 0 位）評審完成，或原本 2 位評審中有一位因利益衝突被排除，該作品就不會出現在排名裡。請到「評審設定」確認該作品的評審指派與完成進度，補齊後重新計算結果即可。"
      },
      "announcementNotSent": {
        "q": "發布公告後，學生沒有收到 Email？",
        "a": "公告預設只會顯示在網站；要寄 Email，必須在發布時勾選「同時寄 Email 通知」，或事後在公告清單按「寄送 Email」。若已寄出仍收不到，請檢查：收件人條件與「預計寄送」人數是否符合預期、收件人的垃圾郵件匣，以及稽核紀錄中該次寄送的失敗人數。"
      },
      "announcementLimit": {
        "q": "公告 Email 顯示超過上限，或想一次寄給很多人？",
        "a": "每次寄送最多 300 位收件人，超過時請縮小條件（例如依類別、輪次或報名欄位分次寄送）。第一次使用建議先用「寄測試信給我自己」確認內容，再用小範圍條件實際寄出，確認沒問題後再擴大範圍。"
      },
      "emailRecall": {
        "q": "公告 Email 寄出後可以收回或更正嗎？",
        "a": "不行。已寄出的 Email 無法收回，之後編輯或刪除公告也不會更新已寄出的信。寄出前請務必看「信件預覽」並先寄測試信給自己；若內容有誤，請發布一則新公告更正說明。"
      },
      "needsUpdateEmpty": {
        "q": "「報名資料」頁沒有出現「需補填的報名資料」區塊？",
        "a": "沒有人需要補填時，整個區塊不會顯示。「需補填」指持有學生角色、且已儲存的答案不符合目前已發布報名表單的人；學生補填並儲存後會自動從名單消失。另外，「寄測試信給我自己」與「傳送補填提醒」按鈕只有具備隊伍管理權限的人看得到。"
      }
    }
  },
  "boundary": {
    "heading": "與平台管理操作手冊的邊界",
    "description": "本手冊涵蓋「如何營運自己負責的競賽」；跨競賽治理、Super Admin、平台使用者與評審治理、帳號停權、Session 撤銷等平台層級操作，屬於平台管理操作手冊的範圍，本手冊不重複說明。",
    "adminGuideCta": "NAPAICP 平台管理操作手冊"
  },
  "cta": {
    "heading": "還有其他問題？",
    "howtoCta": "回到快速開始"
  },
  "events": {
    "heading": "活動營運（接駁車驗票、公告與成員）",
    "description": "活動（例如 TAAI 2026，/events/taai-2026）的現場營運由活動成員執行，與競賽主辦權限分開：競賽主辦方不會自動成為活動成員，只有被加入的成員與平台超級管理員具有活動權限。授權一律在伺服器依能力判斷。活動由平台以資料遷移建立，目前沒有建立活動的畫面。",
    "items": [
      {
        "title": "活動成員與角色",
        "description": "Owner 全部功能含成員管理；Manager 公告、Email 推播、餐飲匯出、服務單；Scanner 驗票與乘客名單；Viewer 僅看報表。以已驗證 Email 加入，可先加入（顯示「待註冊」），對方註冊並驗證後生效。單活動最多 50 位成員，最後一位 Owner 不能被移除或降級。"
      },
      {
        "title": "進入主辦方後台",
        "description": "有活動成員身分者，帳號選單會出現「活動管理」（最多 5 個活動），進入 /events/:slug/admin。後台分頁：總覽（KPI：已預約座位、候補、已驗票、班次數，附資料來源與更新時間）、公告、服務台、成員。"
      },
      {
        "title": "公告與 Email 推播",
        "description": "可發布中英文雙語公告（一般、重要、緊急）並撤回。Email 推播在營運管理的「公告 Email」：先預覽收件對象（人數與遮罩樣本），確認後才寄出；每人每則至多一次、單次 500 位、寄出後無法撤回。"
      },
      {
        "title": "現場驗票與乘客名單",
        "description": "Scanner 與 Owner 在 /events/:slug/staff/check-in 以相機或貼上憑證驗票，離線時暫存、恢復後同步（一次最多 200 筆，伺服器為準，同一憑證只算一次成功）。乘客名單可搜尋、篩選未驗票與候補，不含電話；只有 Owner 能載入緊急聯絡電話，每次載入留稽核。"
      },
      {
        "title": "營運管理（Owner）",
        "description": "志工班表（以 Email 指派）、海報配置匯入與設備申請核准、講者名單與簡報檔（僅 PDF、PPTX，30 MB 內，一律先隔離，需本機防毒檢查後才核准）。"
      },
      {
        "title": "餐飲、客服與資料保存",
        "description": "儀表板只顯示餐飲彙總；Owner、Manager 可匯出明細（每次留稽核）。服務台可把案件改為處理中、已解決或已結案。餐飲、乘車聯絡與提醒資料於活動結束後 30 天自動刪除。"
      }
    ],
    "links": [
      {
        "to": "/help/reference/events-overview",
        "label": "活動平台總覽"
      },
      {
        "to": "/help/organizer/event-console-and-members",
        "label": "如何管理活動成員與主辦方後台"
      },
      {
        "to": "/help/organizer/event-day-check-in",
        "label": "如何在活動現場驗票與核對乘客名單"
      }
    ]
  }
}
